import { PageHero } from "../components/common/PageHero";
import { PhotoBreak } from "../components/common/PhotoBreak";
import { FinalCta } from "../components/common/FinalCta";
import { Reveal } from "../components/motion/Reveal";
import { IMAGES } from "../data/site";
import { useSiteData, useC, fileUrl } from "../context/SiteData";

const Hakkimizda = () => {
  const { images, loaded } = useSiteData();
  const c = useC();
  const aboutSrc = images.about ? fileUrl(images.about) : loaded ? IMAGES.about : null;
  const breakSrc = images.photoBreak ? fileUrl(images.photoBreak) : loaded ? IMAGES.photoBreak : null;

  return (
    <>
      <PageHero
        title={c.ph_hakkimizda_title}
        subtitle={c.ph_hakkimizda_subtitle}
        desc={c.ph_hakkimizda_desc}
      />
      <section data-testid="hakkimizda-story" className="section-y">
        <div className="container-x grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
          <div>
            <Reveal>
              <p className="label flex items-center gap-3 text-ink-500">
                <span className="inline-block h-px w-8 bg-ink-400" />
                {c.about_label}
              </p>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-4 text-3xl font-bold leading-[1.15] tracking-tight text-ink-900 sm:text-4xl">
                {c.about_title}
              </h2>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="mt-6 text-base leading-relaxed text-ink-500 sm:text-lg">
                {c.about_p1}
              </p>
            </Reveal>
            <Reveal delay={0.22}>
              <p className="mt-4 text-base leading-relaxed text-ink-500 sm:text-lg">
                {c.about_p2}
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <div className="group overflow-hidden">
              {aboutSrc ? (
                <img src={aboutSrc} alt="Yalı Yurt öğrenci yaşamı" loading="lazy" className="aspect-[4/3] w-full object-cover saturate-[0.92] transition-[transform,filter] duration-700 group-hover:scale-[1.02] group-hover:saturate-100" />
              ) : (
                <div className="aspect-[4/3] w-full animate-pulse bg-cream-200" />
              )}
            </div>
          </Reveal>
        </div>
      </section>

      <PhotoBreak image={breakSrc} quote={c.photo_break_quote} />

      <section data-testid="hakkimizda-values" className="section-y">
        <div className="container-x">
          <Reveal>
            <h2 className="max-w-xl text-3xl font-bold leading-[1.15] tracking-tight text-ink-900 sm:text-4xl">
              {c.about_values_title}
            </h2>
          </Reveal>
          <div className="mt-12 border-t border-line">
            {c.milestones.map((m, i) => (
              <Reveal key={m.no} delay={Math.min(i * 0.05, 0.2)}>
                <div className="grid grid-cols-[auto_1fr] items-baseline gap-5 border-b border-line py-8 sm:grid-cols-[80px_300px_1fr] sm:gap-8" data-testid={`milestone-${m.no}`}>
                  <span className="text-xs font-bold tracking-[0.2em] text-ink-400">{m.no}</span>
                  <h3 className="text-xl font-bold tracking-tight text-ink-900 sm:text-2xl">{m.title}</h3>
                  <p className="col-span-2 text-sm leading-relaxed text-ink-500 sm:col-span-1 sm:text-base">{m.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <FinalCta />
    </>
  );
};

export default Hakkimizda;
